export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Celkem k odečtení"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provize"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["K připsání"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze vypočítat částku"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nedostatek prostředků pro platbu"])}
}